var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-element-loading',{attrs:{"is-full-screen":"","active":_vm.loading,"spinner":"bar-fade-scale","color":"#152d51"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }